/*
SELECT CONCAT([Code], ': ', Id, ',')
FROM [MuellerHomeowner].[dbo].[AppraisalWorkflowStatuses]
ORDER BY Id
- this class has some results not included in that query though so idk if those results should be used alone
*/

export const appraisalWorkflowStatusTypeEnum =
{
  ORDER_SUBMITTED: 0,
  UNASSIGNED: 1,
  AWAITING_FIELD_REPORT: 2,
  AVAILABLE_TO_APPRAISER: 3,
  REJECTED_TO_FIELD: 4,
  APPRAISAL_SUBMITTED: 5,
  PENDING_APPRAISAL_QA: 6,
  IN_APPRAISAL_QA: 7,
  ASSIGNED_TO_QA_MANAGER: 8,
  REJECTED_TO_APPRAISER: 9,
  COMPLETION_PENDING: 10,
  CUSTOMER_REJECTED: 11,
  COMPLETED: 12,
  RECONSIDERATION_PENDING: 13,
  FIELD_RECONSIDERING: 14,
  APPRAISER_RECONSIDERING: 15,
  CANCELLED_PRE_INSPECTION: 16,
  CLOSED_POST_INSPECTION: 17,
  CLOSED_PRE_APPRAISAL: 18,
  PENDING_APPRAISAL_ASSIGNMENT: 21,

  APPRAISAL_SUBMITTAL_VERIFICATION: 500,

  VEROS_PREVIEW_REQUESTED: 501,
  VEROS_PREVIEW_RESULT_ERROR: 502,
  VEROS_PREVIEW_RESULT_SUCCESS: 503,
  VEROS_PREVIEW_ERROR_APPRAISER: 504,

  GAAR_PREVIEW_REQUESTED: 511,
  GAAR_PREVIEW_RESULT_ERROR: 512,
  GAAR_PREVIEW_RESULT_SUCCESS: 513,
  GAAR_PREVIEW_ERROR_APPRAISER: 514,
  
  UCDP_SUBMITTED_PENDING_RESPONSE: 1000,
  UCDP_RESULT_RECEIVED_WITH_ERRORS: 1002,
  UCDP_RESULT_RECEIVED_NO_ERRORS: 1003,
  SUBMITTING_TO_CUSTOMER: 1004,

  AWAITING_ELIGIBILITY_DECISION: 2000,
  APPRAISAL_WAIVED: 2001,
  
  //Appraisal Manager Case Actions
  ACTION_01: 9000,
  ACTION_02: 9001,

  ORDER_PAYMENT_REQUIRED: 3001,
  ORDER_PAYMENT_PENDING: 3002,
  ORDER_PAYMENT_EXPIRED: 3003,
  ORDER_PAYMENT_DECLINED: 3004,

  REOPEN_CANCELLED_PRE_INSPECTION: 4001,
  REOPEN_CLOSED_POST_INSPECTION: 4002,

  APPRAISAL_PRODUCT_CONVERSION: 5000,
  CLOSED_PRE_INSPECTION: 5001,
};